import { Modal } from "react-bootstrap"

const DeleteWarning = ({
    showDeleteWarningModal,
    setShowDeleteWarningModal,
    selectedDataToDelete,
    setSelectedDataToDelete,
    handleDeleteTerritory
}) => {
    return (
        <Modal
            show={showDeleteWarningModal}
            onHide={() => setShowDeleteWarningModal(false)}
            backdrop="static"
            keyboard={false}
            className="modal-md"
        >
            <Modal.Body>
                <h6 className='pb-3 fw-semibold'>Delete "{selectedDataToDelete?.territory_name}" Territory</h6>
                <p>
                    Are you sure you want to remove this territory ?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-outline-secondary flat-btn text-secondary"
                    onClick={() => { setSelectedDataToDelete(''); setShowDeleteWarningModal(false) }}
                    data-bs-dismiss="modal">
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-danger btn-blue"
                    data-bs-dismiss="modal"
                    onClick={() => { handleDeleteTerritory(selectedDataToDelete); setShowDeleteWarningModal(false) }}
                >
                    Yes, Delete
                </button>
            </Modal.Footer>
        </Modal>
    )
}
export default DeleteWarning